module.exports = __webpack_public_path__ + "static/img/sushi.cf5fbbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/collage/papercuts/sushi.jpg
// module id = n1zq
// module chunks = 1